/**
 * Русское склонение по числу: 1 день, 2 дня, 5 дней.
 * Без этого счётчик стрика читается как машинный перевод.
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;
  const mod10 = n % 10;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}
